import { render, staticRenderFns } from "./CodPostales.vue?vue&type=template&id=27590c84&"
import script from "./CodPostales.vue?vue&type=script&lang=js&"
export * from "./CodPostales.vue?vue&type=script&lang=js&"
import style0 from "./CodPostales.vue?vue&type=style&index=0&id=27590c84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports